import type { DataEnabledTag } from "@/App/types/twiageTypes";
import { TagService } from "@/Pages/Cases/tags/TagService";

export const saveDataEnabledTags = async (dataEnabledTags: DataEnabledTag[], caseId: string): Promise<void> => {
  const promises = [];
  for (const dataTag of dataEnabledTags) {
    const fields = dataTag.values?.flatMap((value) => value.fields ?? []) ?? [];

    const promise = TagService.addDataEnabledTag({
      caseId,
      fields,
      tagId: dataTag.id,
    });

    promises.push(promise);
  }

  await Promise.all(promises);
};
